<template>
  <PhoneFormatter v-model="modelValue" >
    <template #default="{ on, attrs }" >
      <v-text-field test-tag="tag-28"
        v-bind="{...$attrs, ...attrs}"
        v-on="{...$listeners, ...on}"
        outlined
        :clearable="$store.getters.use_keyboard ? true : clearable"
        dense
        filled
      >
      </v-text-field>
    </template>
  </PhoneFormatter>
</template>

<script>

import PhoneFormatter from './PhoneFormatter.vue'

export default {
  props: {
    value: String,
    clearable: Boolean
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(v) {
        if (v[0] != '+') {
          v = '+' + v
        }
        this.$emit('input', v)
      }
    },
    valid(){
      return this.$refs['phonefield']
    }
  },
  components: {
    PhoneFormatter
  },
  watch:{
  }
}
</script>